import { useMutation, useQuery } from '@tanstack/react-query';

import {
  closeSmartOffer,
  getSmartOffer,
} from '@/components/shared/components/smart-offers/services';

import { CLOSE_SMART_OFFER, GET_SMART_OFFER } from '@/constant/query-key';

export function useGetSmartOffer(currentUrl: string) {
  return useQuery({
    queryFn: () => getSmartOffer(currentUrl),
    queryKey: [GET_SMART_OFFER, currentUrl],
  });
}

export function useCloseSmartOffer() {
  return useMutation({
    mutationFn: (id: string) => closeSmartOffer(id),
    mutationKey: [CLOSE_SMART_OFFER],
  });
}
